import { AbstractModel } from '@patsnap/tahiti-core/common/model';
import type { Disposable } from '@patsnap/tahiti-core';
import type { TranslateState } from '../types';

export const TranslateModel = Symbol('TranslateModel');

/**
 * AI翻译模型数据模型
 */
export interface TranslateModel extends AbstractModel<TranslateState>, Disposable { }
